import React from 'react'
import SpeciesFilter from './SpeciesFilter'
import TypeFilter from './TypeFilter'
import ViewFilter from './ViewFilter'
import OptionFilters from './OptionFilters'
import WeekFilter from './WeekFilter'
import 'styles/app/apps/seaLice/filter-bar.scss'

function FilterBar() {
  return (
    <div className="filter-bar">
      <ViewFilter />
      <OptionFilters />
      <SpeciesFilter />
      <TypeFilter />
      <WeekFilter />
    </div>
  )
}

export default FilterBar
